// HTTP method → badge color, shared by the API endpoint cards (the standard
// Swagger/OpenAPI palette). DEFAULT_METHOD_COLOR is used for unknown methods.
export const METHOD_COLORS: Record<string, string> = {
  GET: '#61affe',
  POST: '#49cc90',
  PUT: '#fca130',
  PATCH: '#50e3c2',
  DELETE: '#f93e3e',
  HEAD: '#9012fe',
  OPTIONS: '#0d5aa7',
};

export const DEFAULT_METHOD_COLOR = '#888';

/** Badge color for an HTTP method, falling back to a neutral grey. */
export function methodColor(method: string): string {
  return METHOD_COLORS[method] || DEFAULT_METHOD_COLOR;
}
